import { SHINY_BUTTON_STYLES } from './constants'

/**
 * Get the combined styles for shiny buttons
 * @param {string} type - 'circular' or 'rectangular'
 * @param {boolean} isHovered - Whether button is being hovered
 * @returns {object} Combined styles object
 */
export const getShinyButtonStyles = (type = 'rectangular', isHovered = false) => {
  const baseStyles = {
    ...SHINY_BUTTON_STYLES.base,
    ...SHINY_BUTTON_STYLES[type]
  }

  if (isHovered) {
    if (type === 'circular') {
      return {
        ...baseStyles,
        transform: 'scale(1.05)',
        boxShadow: SHINY_BUTTON_STYLES.hover.boxShadow
      }
    } else {
      return {
        ...baseStyles,
        transform: 'translateY(-1px)',
        boxShadow: `
          inset 0 1px 0 rgba(255,255,255,0.3),
          inset 0 -1px 0 rgba(0,0,0,0.5),
          0 6px 16px rgba(0,0,0,0.4),
          0 0 0 1px rgba(255,255,255,0.2)
        `
      }
    }
  }

  return baseStyles
}

/**
 * Handle mouse enter event for shiny buttons
 * @param {Event} e - Mouse event
 * @param {string} type - Button type
 */
export const handleButtonMouseEnter = (e, type = 'rectangular') => {
  if (type === 'circular') {
    e.target.style.transform = 'scale(1.05)'
    e.target.style.boxShadow = SHINY_BUTTON_STYLES.hover.boxShadow
  } else {
    e.target.style.transform = 'translateY(-1px)'
    e.target.style.boxShadow = `
      inset 0 1px 0 rgba(255,255,255,0.3),
      inset 0 -1px 0 rgba(0,0,0,0.5),
      0 6px 16px rgba(0,0,0,0.4),
      0 0 0 1px rgba(255,255,255,0.2)
    `
  }
}

/**
 * Handle mouse leave event for shiny buttons
 * @param {Event} e - Mouse event
 * @param {string} type - Button type
 */
export const handleButtonMouseLeave = (e, type = 'rectangular') => {
  if (type === 'circular') {
    e.target.style.transform = 'scale(1)'
  } else {
    e.target.style.transform = 'translateY(0)'
  }
  e.target.style.boxShadow = SHINY_BUTTON_STYLES.base.boxShadow
}
